import { Component, Input, ViewChild } from '@angular/core';
import { BaseToolComponent } from '../base-tool.component';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { TintableLayerData } from 'src/app/data/configurator/layer/tintable-layer.data';
import { ContextData } from 'src/app/data/context.data';
import { CanvasEvent } from 'src/app/events/canvas.event';
import { ApplicationData } from 'src/app/data/application.data';
import { CONFIGURATION_MODE } from 'src/app/data/configuration.data';
import { AccordionComponent } from 'src/app/components/ui/accordion/accordion.component';

@Component({
  selector: 'tools-menu',
  templateUrl: './tools-menu.component.html',
  host: {
    class: 'tools-menu'
  }
})
export class ToolsMenuComponent extends BaseToolComponent {

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data;
      this.setLabel();
    }
  }
  get label(): LabelData {
    return this._labelData;
  }

  @Input() set layer(data: LayerData) {
    if (this._layerData != data) {
      this._layerData = data;
      this.setLayer();
    }
  }
  get layerData(): LayerData {
    return this._layerData;
  }

  @ViewChild('accordion') accordion:AccordionComponent;

  public menuOpened:boolean = true;

  public ContextData = ContextData;
  public CanvasEvent = CanvasEvent;
  public CONFIGURATION_MODE = CONFIGURATION_MODE;

  /**
	 * Constructor
	 */
  constructor(public applicationData: ApplicationData) {
    super();

    this.applicationData.configuration.onModeChange.subscribe(() => {

        if(this.applicationData.configuration.mode == CONFIGURATION_MODE.EXCEL){
          // console.log(this.accordion.groups.last);
          this.accordion.openGroup(this.accordion.groups.last);
          setTimeout(() => {
            document.querySelector(".excel-panel__button").scrollIntoView({behavior:'smooth'})
          }, 500);
        }
    });
  }

	/**
	 * On init
	 */
  ngOnInit() {

  }

  /**
	 * Set layer
	 */
  protected setLayer(): void {

  }

  /**
	 * Toggle menu
	 */
  public toggleMenu(): void {
    this.menuOpened = !this.menuOpened;
  }



	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
